module.exports = __webpack_public_path__ + "img/burger-blue-close.ae98dc7b.svg";